var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 444.2816,
    height: 444.2816,
    viewBox: "0 0 444.2816 444.2816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdbdbd;}.cls-2{fill:#adadad;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 222.1408,
    cy: 222.1408,
    r: 222.1307
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.32,344.91q-21.7974,8.9269-43.5978,17.8461c-6.0191,2.4539-11.4415.919-14.1776-4.1566a14.59,14.59,0,0,1-1.5381-5.2459q-6.3186-58.3059-12.5208-116.6244c-.5247-4.9-1.01-9.8062-1.6328-14.6944-1.0525-8.2671-7.9948-15.7016-16.5956-17.905a106.0305,106.0305,0,0,1-27.0885-11.19c-22.232-12.9252-29.7214-33.7827-25.9525-57.843,3.865-24.6727,22.89-44.77,46.54-50.1793,25.5672-5.8478,50.6732,3.554,65.777,24.3687,10.1038,13.9243,12.0377,29.0675,7.6423,45.3732a105.1376,105.1376,0,0,1-10.5962,25.44c-6.01,10.374-5.4388,19.0518,1.9558,28.362q39.7,49.9843,79.3882,99.9776c.5035.6342.9955,1.28,1.4513,1.9488,4.2088,6.1745,2.2378,13.323-4.6576,16.2955-6.8367,2.9472-13.7658,5.68-20.6557,8.5033Q281.1922,340.05,269.32,344.91Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsKey);
export default __webpack_public_path__ + "static/media/icons-key.07706af246409a2cd63b76e7bc98f0ac.svg";
export { ForwardRef as ReactComponent };